import React from 'react';
import ReportingSalesPage from '../components/ReportingSalesPage';

const ReportingSalesApp = (props) => (
  <ReportingSalesPage {...props} />
);

export default ReportingSalesApp;
